import type { AuditedEntityDto, PagedAndSortedResultRequestDto } from '@abp/ng.core';

export interface PickUpDto extends AuditedEntityDto<number> {
  name?: string;
  address?: string;
  email?: string;
  province?: string;
  city?: string;
  isActive: boolean;
  isVisible?: boolean;
  colppyWarehouseName?: string;
}

export interface CreatePickUpDto {
  name: string;
  address: string;
  email: string;
  colppyWarehouseName?: string;
  province?: string;
  city?: string;
  isActive: boolean;
  isVisible?: boolean;
}

export interface GetPickUpDto extends PagedAndSortedResultRequestDto {
  keyword?: string;
}

export interface UpdatePickUpDto {
  name: string;
  address: string;
  email: string;
  province?: string;
  city?: string;
  isActive: boolean;
  isVisible?: boolean;
  colppyWarehouseName?: string;
}
